<template>
  <div v-if="isLoading">
    <h4>Guardando plan... <img src="https://cdn.pixabay.com/animation/2023/05/02/04/29/04-29-06-428_512.gif"
        alt="locader" v-if="isLoading" style="height: 10% !important;width: 10% !important;" />
    </h4>
  </div>
  <div v-if="!isLoading">
    <!-- Modal de redirigir a sección plan favorito -->
    <ModalConfirm ref="confirmModalFavorite" id="confirmModalFavorite" title="Plan favorito guardado"
      message='Su plan ha sido guardado correctamente. ¿Desea que sea redirigido a la sección "Planes aducción favoritos"?'
      confirm="Sí, redirigirme ahora" reject="No, seguir en esta sección"
      @confirmClick="$router.push({ name: 'favorite-plan' })" />
    <!-- Modal de actualizar plan favorito -->
    <ModalConfirm ref="updateFavoriteSuccessModal" id="updateFavoriteSuccessModal"
      title="Plan favorito actualizado con éxito"
      message="Su plan ha sido actualizado correctamente ¿Quiere volver a la pantalla de inicio?" confirm="Aceptar"
      reject="No, seguir en esta sección" @confirmClick="$router.push({ name: 'wizard-step-0' })" />
    <!-- Modal de reusar plan -->
    <ModalConfirm ref="confirmModalReuse" id="confirmModalReuse" title="Reusar parámetros"
      message="¿Desea reutilizar los parámetros como base para recalcular un nuevo plan de aducción?"
      confirm="Sí, reutilizar parámetros" reject="No, seguir aquí" @confirmClick="reusePlanConfirm" />
    <div class="d-flex justify-content-between">
      <button :class="isReusable ? 'd-inline' : 'd-none'" type="button" class="btn btn-primary me-2" @click="reusePlan"
        title="Usar configuración guardad para generar un plan de aducción nuevo">
        <i class="fa-solid fa-recycle"></i>
        <span class="ms-2">Reusar plan</span>
      </button>
      <button type="button" class="btn btn-success me-2" @click="savePlan" title="Guardar modificaciones">
        <i class="fas fa-save"></i>
        <span class="ms-2">Guardar plan</span>
      </button>
      <DownloadButton id="expxlsx" label="Exportar Excel" compClass="btn-warning"
        title="Exportar plan aduccion en formato Excel" endpoint="media/download/file/" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import BlockFull from "@/components/commons/BlockFull";
import PrevisionService from "@/services/PrevisionService";
import DownloadButton from "@/components/commons/DownloadButton";
import ModalConfirm from "@/components/commons/ModalConfirm";

export default {
  data() {
    return {
      selectedPlan: null,
      idPlan: null,
      isLoading: false,
      volumenMax: []
    };
  },
  props: {
    redirectToFavorites: {
      type: Boolean,
      default: false,
    },
    isFavoriteView: {
      type: Boolean,
      default: false,
    },
    idPlanFavorite: {
      type: Number,
      default: null,
    },
    isReusable: {
      type: Boolean,
      default: false,
    },
    volumesTable: {
      type: Array,
      default: []
    }
  },
  watch: {
  },
  components: {
    BlockFull,
    DownloadButton,
    ModalConfirm,
  },
  computed: {
    ...mapState("planner", [
      "v_dataSet",
      "v_fullDataSet",
      "v_selectedPlan",
      "v_selectedYear",
      "v_selectedCriteria",
      "v_selectedYearPlan",
      "v_availability",
      "v_volumes",
    ]),
  },
  methods: {
    ...mapActions("planner", ["v_updSelectedPlan", "v_updDataSet"]),

    async savePlan() {
      this.isLoading = true;
      //Este retrieveData consigue el id de plan de la base de datos para plan nuevo, sumándole uno.
      if (this.isFavoriteView) {
        this.idPlan = this.idPlanFavorite;
      } else {
        //Este retrieveData consigue el id de plan de la base de datos para plan nuevo, sumándole uno.
        //await this.retrieveData();
        this.idPlan = 1000; // TEMPORAL, LA NUEVA BASE DE DATOS NO TIENE PLAN ID
      }

      let columnasAux = [
        { colspan: "2", label: "", subLabels: ["Fecha", "Dias"] },
        { colspan: "1", label: "Aracena", subLabels: ["hm3"] },
        { colspan: "1", label: "Zufre", subLabels: ["hm3"] },
        { colspan: "1", label: "La Minilla", subLabels: ["hm3"] },
        { colspan: "1", label: "El Gergal", subLabels: ["hm3"] },
        { colspan: "1", label: "Cala", subLabels: ["hm3"] },
        { colspan: "1", label: "Los Melonares", subLabels: ["hm3"] },
      ];
      // Bucle para recorrer y comprobar si las columnas de los distintos planes vienen rellenas

      let planesAux = [
        "planAportaciones",
        "planCaudalEco",
        "planEvaporaciones",
        "planReajustes",
        "planTrasvases",
        "planVolumen",
      ];

      for (const key in this.v_dataSet) {
        if (planesAux.includes(key)) {
          if (this.v_dataSet[key].columnas == []) {
            //console.log(`La key ${key} llega correctamente`)
          } else {
            this.v_dataSet[key].columnas = columnasAux;
          }
        }
      }

      //console.log("DATASET TOTAL", this.v_dataSet)
      //Este bucle for recorre los 4 arrays de datos a la vez por día de quincena, itera sombre planVolumen porque tiene una fila más
      //prepara los datos para insertar en la base de datos por embalse y día y ejecuta el post o el put según la vista.
      //console.log("v_dataset", this.v_volumes)

      for (let i = 0; i < this.v_dataSet.planVolumen.filas.length; i++) {
        //Declaro las variables que usaremos, incluyendo los datos de Aducción, volumen, etc para facilitar la lectura.
        let datosAracena = { nombre: "Aracena" };
        let datosZufre = { nombre: "Zufre" };
        let datosMinilla;
        let datosGergal;
        let datosMelonares;
        if (this.isFavoriteView) {
          datosMinilla = { nombre: "Minilla" };
          datosGergal = { nombre: "Gergal" };
          datosMelonares = { nombre: "Melonares" };
        } else {
          datosMinilla = { nombre: "La Minilla" };
          datosGergal = { nombre: "El Gergal" };
          datosMelonares = { nombre: "Los Melonares" };
        }
        let datosCala = { nombre: "Cala" };
        let datosAduccion;
        let datosTrasvases;
        let datosRejaustes;
        let datosAportaciones;
        let datosCaudalEcologico;
        let datosEvaporaciones;
        let datosVolumen = this.v_dataSet.planVolumen.filas[i];
        let datosDisponibilidad;
        if (this.isFavoriteView) {
          datosDisponibilidad = this.quitarArticulos(this.v_availability);
        } else {
          datosDisponibilidad = this.v_availability;
        }
        //console.log("Disponibilidad", datosDisponibilidad)
        let datosVolumenes;
        if (this.$route.fullPath == '/favoriteplan') {
          datosVolumenes = this.volumesTable;
        } else {
          this.v_volumes.forEach(item => {
            if (item.Nombre_Embalse=="El Gergal") {
              item.Nombre_Embalse ="Gergal";
            }else if (item.Nombre_Embalse=="La Minilla") {
              item.Nombre_Embalse = "Minilla";
            }else if (item.Nombre_Embalse=="Los Melonares") {
              item.Nombre_Embalse ="Melonares";
            }
          });
          datosVolumenes = this.v_volumes;
        }

        let datosInsercion;

        //Los meto en un array, ordenándolos según si vamos a guardar nuevo o actualizar favorito:
        // if (this.isFavoriteView) {
        //   datosInsercion = [
        //     datosAracena,
        //     datosCala,
        //     datosGergal,
        //     datosMinilla,
        //     datosMelonares,
        //     datosZufre,
        //   ];
        // } else {
        datosInsercion = [
          datosAracena,
          datosZufre,
          datosMinilla,
          datosGergal,
          datosCala,
          datosMelonares,
        ];
        //}
        // console.log("DATOS", datosAduccion = this.v_dataSet.planAduccion.filas)
        //Si estamos en el ultimo loop del bucle controlo el nullpointer de los planes que no son Volumen:
        if (i == this.v_dataSet.planVolumen.filas.length - 1) {
          datosAduccion = this.v_dataSet.planAduccion.filas[i - 1];
          datosTrasvases = this.v_dataSet.planTrasvases.filas[i - 1];
          datosRejaustes = this.v_dataSet.planReajustes.filas[i - 1];
          datosCaudalEcologico = this.v_dataSet.planCaudalEco.filas[i - 1];
          datosAportaciones = this.v_dataSet.planAportaciones.filas[i - 1];
          datosEvaporaciones = this.v_dataSet.planEvaporaciones.filas[i - 1];
        } else {
          datosAduccion = this.v_dataSet.planAduccion.filas[i];
          datosTrasvases = this.v_dataSet.planTrasvases.filas[i];
          datosRejaustes = this.v_dataSet.planReajustes.filas[i];
          datosCaudalEcologico = this.v_dataSet.planCaudalEco.filas[i];
          datosAportaciones = this.v_dataSet.planAportaciones.filas[i];
          datosEvaporaciones = this.v_dataSet.planEvaporaciones.filas[i];
        }

        if (this.isFavoriteView) {
          //Como los Datos de Aducción tienen una estructura diferente, añado los valores a mano:
          // datosMinilla["aduccionM"] =
          //   datosAduccion.masasAgua[2].caudal.value != "-"
          //     ? datosAduccion.masasAgua[2].caudal.value
          //     : 0;
          datosMinilla["aduccionH"] =
            datosAduccion.masasAgua[3].extraido.value != "-"
              ? datosAduccion.masasAgua[3].extraido.value
              : 0;
          // datosMelonares["aduccionM"] =
          //   datosAduccion.masasAgua[3].caudal.value != "-"
          //     ? datosAduccion.masasAgua[3].caudal.value
          //     : 0;
          datosMelonares["aduccionH"] =
            datosAduccion.masasAgua[6].extraido.value != "-"
              ? datosAduccion.masasAgua[6].extraido.value
              : 0;
          // datosGergal["aduccionM"] =
          //   datosAduccion.masasAgua[1].caudal.value != "-"
          //     ? datosAduccion.masasAgua[1].caudal.value
          //     : 0;
          datosGergal["aduccionH"] =
            datosAduccion.masasAgua[4].extraido.value != "-"
              ? datosAduccion.masasAgua[4].extraido.value
              : 0;
        } else {
          //Como los Datos de Aducción tienen una estructura diferente, añado los valores a mano:
          // datosMinilla["aduccionM"] =
          //   datosAduccion.masasAgua[1].caudal.value != "-"
          //     ? datosAduccion.masasAgua[1].caudal.value
          //     : 0;
          datosMinilla["aduccionH"] =
            datosAduccion.masasAgua[1].extraido.value != "-"
              ? datosAduccion.masasAgua[1].extraido.value
              : 0;
          // datosGergal["aduccionM"] =
          //   datosAduccion.masasAgua[3].caudal.value != "-"
          //     ? datosAduccion.masasAgua[3].caudal.value
          //     : 0;
          datosGergal["aduccionH"] =
            datosAduccion.masasAgua[3].extraido.value != "-"
              ? datosAduccion.masasAgua[3].extraido.value
              : 0;
          // datosMelonares["aduccionM"] =
          //   datosAduccion.masasAgua[2].caudal.value != "-"
          //     ? datosAduccion.masasAgua[2].caudal.value
          //     : 0;
          datosMelonares["aduccionH"] =
            datosAduccion.masasAgua[2].extraido.value != "-"
              ? datosAduccion.masasAgua[2].extraido.value
              : 0;
        }
        //console.log("Datos Aducción", datosInsercion)
        //Recorro el array de emabalses para añadir los datos:
        for (let j = 0; j < datosInsercion.length; j++) {
          //Datos comunes:
          //console.log("fecha ", datosAduccion.fecha)
          //datosInsercion[j]["idPlan"] = this.idPlan;
          if (this.isFavoriteView) {
            datosInsercion[j]["fecha"] = datosAduccion.fecha.split("/")[2] + "-" + datosAduccion.fecha.split("/")[1] + "-" + datosAduccion.fecha.split("/")[0];
          } else {
            datosInsercion[j]["fecha"] =
              this.v_selectedYear +
              "-" +
              datosAduccion.fecha.slice(3) + "-" + datosAduccion.fecha.slice(0, 2);
          }

          datosInsercion[j]["dias"] = datosVolumen.ndias;
          console.log("dias", datosVolumen.ndias, datosInsercion[j]["fecha"])
          datosInsercion[j]["criteria"] = this.v_selectedCriteria;
          //Datos de volumen:
          datosInsercion[j]["volumenEmbalsado"] =
            datosVolumen.masasAgua[j].extraido.value != "-" &&
              datosVolumen.masasAgua[j].extraido.value != "NaN"
              ? datosVolumen.masasAgua[j].extraido.value
              : 0;
          //Datos de trasvases:
          datosInsercion[j]["trasvases"] =
            datosTrasvases.masasAgua[j].extraido.value != "-"
              ? datosTrasvases.masasAgua[j].extraido.value
              : 0;
          console.log("trasvases", datosTrasvases.masasAgua[j].extraido.value, datosInsercion[j]["trasvases"])
          //Datos de trasvases editados:
          datosInsercion[j]["trasvasesU"] = datosTrasvases.masasAgua[j].editado
            ? 1
            : 0;
          //Datos de reajustes:
          datosInsercion[j]["reajustes"] =
            datosRejaustes.masasAgua[j].extraido.value != "-"
              ? datosRejaustes.masasAgua[j].extraido.value
              : 0;
          //Datos de reajustes editados:
          datosInsercion[j]["reajustesU"] = datosRejaustes.masasAgua[j].editado
            ? 1
            : 0;
          //Datos de Caudales Ecologicos 
          datosInsercion[j]["caudalEco"] =
            datosCaudalEcologico.masasAgua[j].extraido.value != "-"
              ? datosCaudalEcologico.masasAgua[j].extraido.value
              : 0;
          //Datos de Caudales Ecologicos editados:
          datosInsercion[j]["caudalEcoU"] = datosCaudalEcologico.masasAgua[j].editado
            ? 1
            : 0;
          // Datos de aportaciones
          datosInsercion[j]["aportaciones"] =
            datosAportaciones.masasAgua[j].extraido.value != "-"
              ? datosAportaciones.masasAgua[j].extraido.value
              : 0;
          //Datos de Caudales Ecologicos editados:
          datosInsercion[j]["aportacionesU"] = datosAportaciones.masasAgua[j].editado
            ? 1
            : 0;
          // Datos de evaporaciones
          // Datos de aportaciones
          datosInsercion[j]["evaporaciones"] =
            datosEvaporaciones.masasAgua[j].extraido.value != "-"
              ? datosEvaporaciones.masasAgua[j].extraido.value
              : 0;
          //Datos de Caudales Ecologicos editados:
          datosInsercion[j]["evaporacionesU"] = datosEvaporaciones.masasAgua[j].editado
            ? 1
            : 0;
          //Datos de disponibilidad
          // if (i!=24 || i!=25) {

          // } else {
          //   console.log("No hay disponibilidad para ", datosDisponibilidad);
          // }
          //console.log(j, i, "disponibilidad")
          //Datos de volumen
          for (let l = 0; l < datosVolumenes.length; l++) {
            let nVol = datosVolumenes[l].Nombre_Embalse;
            let nIns = datosInsercion[j].nombre;
            if (nIns === "La Minilla") nIns = "Minilla";
            if (nIns === "El Gergal") nIns = "Gergal";
            if (nIns === "Los Melonares") nIns = "Melonares";

            if (nVol == nIns) {
              if (
                datosInsercion[j]["fecha"].includes("11-01") &&
                datosVolumenes[l]["01/11"]
              ) {
                datosInsercion[j]["volMax"] = datosVolumenes[l]["01/11"].volMax;
                datosInsercion[j]["volMin"] = datosVolumenes[l]["01/11"].volMin;
                datosInsercion[j]["volMinUtil"] = datosVolumenes[l]["01/11"].volMinUtil;

              } else {
                if (datosVolumenes[l]["01/01"]) {
                  datosInsercion[j]["volMax"] = datosVolumenes[l]["01/01"].volMax;
                  datosInsercion[j]["volMin"] = datosVolumenes[l]["01/01"].volMin;
                  datosInsercion[j]["volMinUtil"] = datosVolumenes[l]["01/01"].volMinUtil;
                } else {
                  datosInsercion[j]["volMax"] = datosVolumenes[l].VolumenMaximo;
                  datosInsercion[j]["volMin"] = datosVolumenes[l].VolumenMinimo;
                  datosInsercion[j]["volMinUtil"] = datosVolumenes[l].VolumenMinimoUtil;
                }
              }
            }
          }
          //Al acabar la quincena, volvemos a comprobar que es la útlima iteración.
          //si es asi significa que hemos llegado a final de año y tenemos que crear una inserción adicional
          //para el 01/01 del año siguiente, con los datos del planVolumen correctos. El resto dan igual pues no se consultan.
          //Finalmente se suben los datos de todos los embalses y se empieza el bucle para la siguiente.
          if (i == this.v_dataSet.planVolumen.filas.length - 1) {
            datosInsercion[j]["fecha"] = `${parseInt(this.v_selectedYear) + 1}-01-01`;
            //datosInsercion[j]["disponibilidad"] = 0;
          }
          // if (this.isFavoriteView) {
          //   // await this.postFavoritePlan(datosInsercion[j]);
          //   //this.putFavoritePlan(datosInsercion[j]);
          // } else {
          //   console.log("A insertar " + JSON.stringify(datosInsercion[j]))
          //   if(i == 0 && j==0){
          //     console.log("Crea plan")
          //     console.log("A insertar ", datosInsercion[j] )
          //   this.postFavoritePlan({dato : datosInsercion[j], prim : true});
          //   console.log(`Se ha guardado el dato ${datosInsercion[j]}`)
          //   } else {
          //     console.log("A insertar 2", datosInsercion[j] )

          //   this.postFavoritePlan({dato : datosInsercion[j], prim : false});
          //   console.log(`Se ha guardado el dato ${datosInsercion[j]}`)

          //   }
          // console.log(`fecha ${datosIn.sercion[j]["fecha"]}`)
          datosInsercion[j]["disponibilidad"] = this.addDisponibility(datosInsercion[j]["fecha"], j, datosDisponibilidad, datosInsercion);

        }
        console.log(datosInsercion, "datosInsercion")
        if (i == 0) {
          //console.log("Crea plan")
          if (new Date(datosInsercion[0].fecha) < new Date() && this.$route.fullPath != '/favoriteplan') {
            let dataReal = await this.getRealPlan(datosInsercion[0].fecha.split("-")[0], datosInsercion[0].fecha);
            datosInsercion = datosInsercion.map(item => {
              const itemReal = dataReal.find(real => real.nombre === item.nombre);
              if (itemReal) {
                return {
                  ...item,
                  aportaciones: itemReal.aportaciones,
                  caudalEco: itemReal.caudalEco,
                  evaporaciones: itemReal.evaporaciones,
                  trasvases: itemReal.trasvases,
                  reajustes: itemReal.reajustes,
                  dias: itemReal.Dias,
                };
              }
              return item;
            });
            await this.postFavoritePlan({ dato: datosInsercion, prim: true, selectedYear: this.v_selectedYear });

          } else {
           await this.postFavoritePlan({ dato: datosInsercion, prim: true, selectedYear: this.v_selectedYear });
          }
        } else {
          if (new Date(datosInsercion[0].fecha) < new Date() && this.$route.fullPath != '/favoriteplan') {
            //datosInsercion[0].fecha.split("-")[0], datosInsercion[0].fecha
            let dataReal2 = await this.getRealPlan(datosInsercion[0].fecha.split("-")[0], datosInsercion[0].fecha);
            datosInsercion = datosInsercion.map(item => {
              const itemReal = dataReal2.find(real => real.nombre === item.nombre);
              if (itemReal) {
                return {
                  ...item,
                  aportaciones: itemReal.aportaciones,
                  caudalEco: itemReal.caudalEco,
                  evaporaciones: itemReal.evaporaciones,
                  trasvases: itemReal.trasvases,
                  reajustes: itemReal.reajustes,
                  dias: itemReal.Dias,
                };
              }
              return item;
            });
            await this.postFavoritePlan({ dato: datosInsercion, prim: false, selectedYear: this.v_selectedYear });
          }
          else {
            await this.postFavoritePlan({ dato: datosInsercion, prim: false, selectedYear: this.v_selectedYear });
          }
          // console.log(`${datosInsercion}`)
          // await this.postFavoritePlan({dato : datosInsercion, prim : false,selectedYear: this.v_selectedYear});
          //console.log('Se ha guardado el dato ', datosInsercion)

        }
      }
      this.isLoading = false;
      if (this.redirectToFavorites) {
        //console.log("Redirigir a favoritos");
        this.$nextTick(() => {
          this.$refs.confirmModalFavorite.showModal();
        });

      }
    },
    quitarArticulos(obj) {
      const articulos = ["El ", "La ", "Los "]; // Espacios para evitar coincidencias parciales
      let nuevoObjeto = {};
      Object.keys(obj).forEach(clave => {
        let nuevaClave = clave;
        articulos.forEach(articulo => {
          if (clave.startsWith(articulo)) {
            nuevaClave = clave.replace(articulo, "");
          }
        });
        nuevoObjeto[nuevaClave] = obj[clave];
      });
      return nuevoObjeto;
    },

    //Método para recuperar datos
    async retrieveData() {
      //Llamada al servicio de obtención del último ID del plan y sumarle uno para forzar el auto incremento
      await PrevisionService.getIdPlan()
        .then((response) => {
          this.idPlan = response.data[0].ID + 1;
        })
        .catch((err) => {
          console.log("Se ha producido un error al solicitar los volúmenes: " + err);
        });
    },
    //Método para subir a la base de datos el plan favorito
    async postFavoritePlan(datosPlan) {
      try {
        const response = await PrevisionService.postFavoritePlan(datosPlan);
      } catch (e) {
        console.error("Error en la solicitud postFavoritePlan:", e);
      }
    },

    async getRealPlan(year, quincena) {
      try {
        const response = await PrevisionService.getRealPlan(year, quincena);
        return response.data; // Devuelve un array vacío si no hay datos
      } catch (e) {
        console.log("Error en la solicitud getRealPlan:", e);
        return []; // Devuelve un array vacío en caso de error
      }
    },
    addDisponibility(fecha, j, datosDisponibilidad, datosInsercion) {
      const [año, mes, dia] = fecha.split("-").map(Number);
      const quincena = dia < 15 ? 1 : 2;
      let numQuincena = (mes - 1) * 2 + (quincena - 1);
      return datosDisponibilidad[datosInsercion[j].nombre][numQuincena];

    },
    //Método para actualizar en a la base de datos el plan favorito
    putFavoritePlan(datosPlan) {
      PrevisionService.putFavoritePlan(datosPlan)
        .then((response) => {
          if (this.redirectToFavorites == false) {
            this.$refs.updateFavoriteSuccessModal.showModal();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // Reusar plan
    reusePlan() {
      this.$refs.confirmModalReuse.showModal();
    },
    reusePlanConfirm() {
      this.$emit("reusePlan");
    },
  },
  async mounted() { },
  watch: {},
};
</script>